module.exports = __webpack_public_path__ + "static/media/people.167436c0.png";